import { Controller } from "stimulus";

export default class extends Controller {
  clickCopy(event) {
    event.preventDefault()
    const clickedElement = event.currentTarget
    const content = document.getElementById(`${event.currentTarget.id}-snippet`).textContent.trim()

    navigator.clipboard.writeText(content)
      .then(() => {
        this.showCopied(clickedElement)
      }).catch(err => {
        console.log('Something went wrong', err);
      })
  }

  showCopied(clickedElement) {
    const originalText = clickedElement.innerHTML
    clickedElement.innerHTML = "Copied!"
    setTimeout(() => {
      clickedElement.innerHTML = originalText
    }, 1000)
  }
}
